import React from 'react';
import PropTypes from 'prop-types';

import ui from '@watsi/ui';

const { Button } = ui.components;

const SubscribeButton = ({ disabled, isSubmitting, isSubmitted, ...props }) => (
  <Button filled large loadable={!isSubmitted} loading={isSubmitting} {...props}>
    <span>{isSubmitted ? 'Subscribed' : 'Subscribe'}</span>
    {isSubmitted && (
      <span className="marginLeft-8">
        <svg className="verticalAlign-baseline" width={15} height={15} viewBox="0 0 21 15" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.1 13.77c-.652.654-1.411.98-2.276.98-.864 0-1.623-.326-2.276-.98L.983 9.22C.661 8.889.5 8.507.5 8.074c0-.432.165-.814.496-1.144a1.55 1.55 0 0 1 1.132-.483c.432 0 .813.16 1.144.483l4.552 4.565 10.25-10.262c.33-.322.711-.483 1.144-.483.432 0 .813.161 1.144.483.322.33.483.712.483 1.145 0 .432-.16.813-.483 1.144L10.1 13.771z" fill="#FFF" fillRule="evenodd" />
        </svg>
      </span>
    )}
  </Button>
);

export default SubscribeButton;
